import { Notifications } from 'app/Notifications'
import { Theme } from 'app/Theme'
import { observer } from 'mobx-react-lite'
import { Main } from 'page/Main'
import { UnavailablePage } from 'page/UnavailablePage/UnavailablePage'
import { useEffect } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const App = observer(() => {
  const inline = opt.inline
  const square = opt.square

  useEffect(() => {
    document.body.classList.toggle('inline', inline)
  }, [inline])

  useEffect(() => {
    document.body.classList.toggle('square', square)
  }, [square])

  useEffect(() => {
    function listener(event: MouseEvent) {
      event.preventDefault()
    }

    if (!inline) return

    document.addEventListener('contextmenu', listener, false)
    return () => document.removeEventListener('contextmenu', listener, false)
  }, [inline])

  if (store.error) return <UnavailablePage />
  if (!store.init) return null

  return (
    <Theme>
      <Main />
      <Notifications />
    </Theme>
  )
})
